import { Component } from "@angular/core";

@Component({
  selector: "icon-info-circle-tramite",
  templateUrl: "./icon-i.svg",
  standalone: true,
  styles: [
    `
      :host {
        display: block;
        color: inherit;
        line-height: 0;
      }
    `,
  ],
})
export class InfoCircleTramiteIconComponent {}
